export function convertURLSearchParams<T extends Record<string, any>>(param: T) {
  if (param === null || param === undefined || param instanceof URLSearchParams) return param;
  const urlSearchParams = new URLSearchParams();
  Object.keys(param).forEach((key) => {
    let value = param[key];

    switch (typeof value) {
      case 'object':
        if (Array.isArray(value)) {
          value.forEach((v) => {
            urlSearchParams.append(key, v);
          });
        } else {
          urlSearchParams.append(key, JSON.stringify(value));
        }
        break;
      case 'function':
      case 'undefined':
        break;
      default:
        urlSearchParams.append(key, String(value));
        break;
    }
  });
  return urlSearchParams;
}

type FilterParams = {
  operator: 'contains' | 'eq';
  keys: string[];
  values: string[];
};

export function convertFilterParams(filterParams: FilterParams[] | FilterParams) {
  const res: string[] = [];
  const filterParamsArray = Array.isArray(filterParams) ? filterParams : [filterParams];

  filterParamsArray.forEach((filterParam) => {
    filterParam.keys.forEach((key) => {
      filterParam.values.forEach((_value) => {
        const value = key === 'phone' ? _value.replace(/\s/g, '') : _value;

        switch (filterParam.operator) {
          case 'eq':
            res.push(`${key} eq '${value}'`);
            break;
          case 'contains':
            res.push(`contains(${key}, '${value}')`);
            break;
          default:
            break;
        }
      });
    });
  });
  return res.join(' or ');
}
